export const BASE_PATH = '/admin';

export const UP_PATH = '/up';

export const SIGNIN_PATH = BASE_PATH + '/signin';

export const LEADS_PATH = BASE_PATH + '/leads';
export const LEAD_DETAIL_PATH = BASE_PATH + '/lead/:id/:tab?';
export const SUBSCRIPTION_DETAIL_PATH = BASE_PATH + '/subscription/:id/details';

export const PATIENTS_PATH = BASE_PATH + '/patients';

export const ORDERS_PATH = BASE_PATH + '/orders';

export const CASES_PATH = BASE_PATH + '/cases';
export const CASE_DETAIL_PATH = BASE_PATH + '/cases/:id/detail';

export const STATUSES_PATH = BASE_PATH + '/statuses';

export const PRODUCTS_PATH = BASE_PATH + '/products';
export const ADD_PRODUCT_PATH = PRODUCTS_PATH + '/add';
export const EDIT_PRODUCT_PATH = PRODUCTS_PATH + '/:id/edit';

export const SUBSCRIPTIONS_PATH = BASE_PATH + '/subscriptions';

export const CHARGES_PATH = BASE_PATH + '/charges';

export const CONTACTS_PATH = BASE_PATH + '/contacts';

export const INTAKES_PATH = BASE_PATH + '/intakes';

export const USERS_PATH = BASE_PATH + '/users';

export const CLIENT_USERS_PATH = BASE_PATH + '/client-users';

export const TICKETS_PATH = BASE_PATH + '/tickets';

export const QUESTIONNAIRES_PATH = BASE_PATH + '/product-questionnaires';

export const VOUCHERS_PATH = BASE_PATH + '/vouchers';

export const TEAMS_PATH = BASE_PATH + '/teams';

export const EXTERNAL_TOKENS_PATH = BASE_PATH + '/external-tokens';

export const PHARMACY_TRACKINGS_PATH = BASE_PATH + '/pharmacy-trackings';

export const TEMPLATES_PATH = BASE_PATH + '/templates';

export const EXPORTS_PATH = BASE_PATH + '/exports';

export const SUPPORT_CHAT_PATH = BASE_PATH + '/support-chat/:id?';

export const GMAIL_PATH = BASE_PATH + '/gmail/:type';

export const GMAIL_THREAD_PATH = BASE_PATH + '/gmail/thread/:id';

export const TYPES_PATH = BASE_PATH + '/types';

export const APPOINTMENTS_PATH = BASE_PATH + '/appointments';

export const FOLLOWUP_PATH = BASE_PATH + '/follow-up';

export const PERMISSIONS_PATH = BASE_PATH + '/permissions';

export const PERMISSION_DETAIL_PATH = BASE_PATH + '/role/:id';

export const LAB_WORKS_PATH = BASE_PATH + '/lab-works';

export const COUPONS_PATH = BASE_PATH + '/coupons';

export const AGENT_SALES_PATH = BASE_PATH + '/agent-sales';
export const SALES_STATS_DETAIL_PATH = BASE_PATH + '/sales-stats';

export const QUIZ_ATTEMPTS_PATH = BASE_PATH + '/quiz-attempts';

export const PATIENT_REFERRALS_PATH = BASE_PATH + '/patient-referrals';

export const LAB_REVIEWS_PATH = BASE_PATH + '/lab-reviews';

export const QUIZ_ANALYTICS_PATH = BASE_PATH + '/quiz-analytics';

export const PRODUCT_VARIANTS_PATH = BASE_PATH + '/product-variants';

export const ADD_TEAM_PATH = BASE_PATH + '/team';

export const EDIT_TEAM_PATH = BASE_PATH + '/team/:id';

export const PHARMACY_PATH = BASE_PATH + '/pharmacy';
